import { useHome } from "@/context/HomeContent";

// WhatsApp click-to-chat link. Number is CMS-editable
// (Homepage & Footer editor -> Footer -> "WhatsApp number").
export const WHATSAPP_DEFAULT_NUMBER = "919673200001";
export const WHATSAPP_MESSAGE = "Hi Jadoo Ki Jhappy! I'd like to enquire about your programs.";

export const whatsAppHref = (number) =>
  `https://wa.me/${String(number || WHATSAPP_DEFAULT_NUMBER).replace(/\D/g, "")}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

export const useWhatsAppHref = () => {
  const { home } = useHome();
  return whatsAppHref(home.footer?.whatsapp);
};
